export enum QuestionTypeEnum {
  NPS = 'NPS',
  TEXT = 'TEXT',
  SINGLE = 'SINGLE',
  MULTI = 'MULTI',
}
